import { render, staticRenderFns } from "./KioskFooter.vue?vue&type=template&id=92a6d2b8&scoped=true"
import script from "./KioskFooter.vue?vue&type=script&lang=js"
export * from "./KioskFooter.vue?vue&type=script&lang=js"
import style0 from "./KioskFooter.vue?vue&type=style&index=0&id=92a6d2b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a6d2b8",
  null
  
)

export default component.exports